<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-double-up`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.145 26.402a1 1 0 001.403 0l9.952-9.797 9.952 9.797a1 1 0 001.403 0l1.421-1.4a1 1 0 000-1.424L24.201 11.69a1 1 0 00-1.403 0L10.724 23.578a1 1 0 000 1.425l1.421 1.399zm1.403 9.907l9.952-9.797 9.952 9.797a1 1 0 001.403 0l1.421-1.399a1 1 0 000-1.425L24.201 21.598a1 1 0 00-1.403 0L10.724 33.485a1 1 0 000 1.425l1.421 1.4a1 1 0 001.403 0z"/></svg>
</template>
<script>

export default {
  name: 'IconDoubleUp',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
